export default (props) => (
    <div className="video_container">
        <img className="video_title" src="../../static/kidsnew/block3_a.png" />
        <div className="video_box">

            <iframe src="https://www.youtube.com/embed/pZHlIHGmwYE?rel=0&autoplay=1" frameBorder="0" allowFullScreen allow="autoplay;" className="video_iframe"></iframe>
        </div>
        <style jsx>{`
          .video_iframe {
            width: 100%;
            padding: 30px 116px;
            height: 94%;
          }
          
          .video_container {
            background-color: #e7ecff;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding-bottom: 20px;
          }
        
          .video_box {
            width: 930px;
            height: 480px;
            background: url(../static/kidsnew/video_box.png) no-repeat center center;
            background-size: 100% 100%;
            margin-left: auto;
            margin-right: auto;
          }
          
            @media (max-width: 960px) {
                .video_box {
                    width: 768px;
                    height: 396px;
                    background: url(../../assets/img/home/video_box.png) no-repeat center center;
                    background-size: 100% 100%;
                    margin-left: auto;
                    margin-right: auto;
                }
                .video_title {
                    width: 100%;
                }
            }
            
            @media (max-width: 768px) {
                .video_box {
                    width: 600px;
                    height: 309px;
                    background: url(../../assets/img/home/video_box.png) no-repeat center center;
                    background-size: 100% 100%;
                    margin-left: auto;
                    margin-right: auto;
                }
                .video_title {
                    width: 100%;
                }
            }
            
            
            @media (max-width: 600px) {
                .video_box {
                    width: 480px;
                    height: 247px;
                    background: url(../../assets/img/home/video_box.png) no-repeat center center;
                    background-size: 100% 100%;
                    margin-left: auto;
                    margin-right: auto;
                }
                .video_title {
                    width: 100%;
                }
            }
            
            @media (max-width: 480px) {
                .video_box {
                    width: 400px;
                    height: 250px;
                    background: none;
                    margin-left: auto;
                    margin-right: auto;
                }
                .video_iframe {
                    padding: 0px 0px;
                }
                .video_title {
                    width: 100%;
                }
            }
            
            @media (max-width: 375px) {
                .video_box {
                    width: 350px;
                    height: 180px;
                    background: none;
                    margin-left: auto;
                    margin-right: auto;
                }
                .video_iframe {
                    padding: 0px 0px;
                }
                .video_title {
                    width: 100%;
                }
            }
            
            @media (max-width: 320px) {
                .video_box {
                    width: 300px;
                    height: 154px;
                    background: none;
                    margin-left: auto;
                    margin-right: auto;
                }
                .video_iframe {
                    padding: 0px 0px;
                }
                .video_title {
                    width: 100%;
                }
            }

          header {
            background-image: url(${props.bg});
            background-position: 50% 50%;
            background-repeat: no-repeat;
            background-size: cover;
            max-width: 100%;
            height: 0;
            padding-bottom: 56%;
            overflow: hidden;
            position: relative;
            background-attachment: fixed;
          }
    
          @media (min-width: 768px) and (max-width: 1200px) {
            header {
              background-attachment: initial;
              background-image: url(${props.mobile_bg});
              padding-bottom: 177.78%;
            }
          }
    
          @media(max-width: 768px){
            header {
              background-attachment: initial;
              background-image: url(${props.mobile_bg});
              padding-bottom: 177.78%;
            }
          }
    
          @media only screen and (min-width: 1366px) and (orientation: landscape) {
            header {
              background-attachment: initial;
            }
          }
    
          @media only screen and (min-width: 1024px) and (orientation: landscape) {
            header {
              background-attachment: initial;
              background-image: url(${props.bg});
              padding-bottom: 56%;
            }
          }
        `}</style>
    </div>
)
